import { inject } from 'mobx-react';
import { ProfileMenuComponent } from './component';
export const ProfileMenu = inject(({ auth, ui }) => ({
    user: auth.userData,
    logout: auth.logout,
    setLanguage: ui.setLanguage,
    showLanguageMenu: ui.showLanguageMenu,
}))(ProfileMenuComponent);
//# sourceMappingURL=index.js.map